import React from 'react'

class CalendarHeader extends React.Component {

  previousMonth () {
    const prev_month = moment(this.props.requested_date).add(-1, 'months').format("YYYY-MMMM-DD")
    this.fetchDataFor(prev_month)
  }

  nextMonth () {
    const next_month = moment(this.props.requested_date).add(1, 'months').format("YYYY-MMMM-DD")
    this.fetchDataFor(next_month)
  }

  fetchDataFor (month) {
    $.getJSON('/schedules/build_events', {eventable: 'calendar', input_date_for_calendar_view: month}, (data) => {
      this.props.onMonthChange(data)
    })
  }

  render () {
    return (
      <div>
        <span className='calendar-header-date'>{moment(this.props.requested_date).format("MMMM YYYY")}</span>
        <i className='prev-month fa fa-angle-left' onClick={this.previousMonth.bind(this)}></i>
        <i className='next-month fa fa-angle-right' onClick={this.nextMonth.bind(this)}></i>
      </div>
    )
  }
}

export default CalendarHeader;